import React from "react";
import "../App.css";

const Skills = (props) =>{
    return <div className="small-con">
        <span>{props.name}</span>
    </div>
}

export default Skills;